import React, { PropTypes } from 'react';

export default class SchoolAdminFrame extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
    };
    // bind this
  }

  render() {
    return (
      <div className="school-admin-frame">
        {this.props.children}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/SchoolAdminFrame.jsx